import {translations} from 'presentation/translations-new';
import type {UseFormReturn} from 'react-hook-form';
import type {TherapyDataSchema} from '../components/AddTherapy/schemas/therapyDataSchema';

const {addSessionToProceed, addValidDate, addValidValue} =
	translations['pt-br'].privateFlow.refund.therapies.validations;

export type HandleErrorsBuilderParams = {
	form: UseFormReturn<TherapyDataSchema>;
	type: 'patient' | 'serviceDate' | 'sessionValue' | 'custom' | 'therapyType';
	index?: number;
	message?: string;
};

export const handleErrorsBuilder = ({
	form,
	type,
	index = 0,
	message,
}: HandleErrorsBuilderParams) => {
	if (type === 'serviceDate') {
		form.setError(`sessions.${index}.serviceDate`, {
			type: 'required',
			message: message || addValidDate,
		});
	} else if (type === 'sessionValue') {
		form.setError(`sessions.${index}.sessionValue`, {
			type: 'required',
			message: message || addValidValue,
		});
	} else if (type === 'custom') {
		form.setError('sessions', {
			type: 'custom',
			message: message || addSessionToProceed,
		});
	} else if (type === 'therapyType') {
		form.trigger('therapyType');
	}
};
